import React from 'react';

export const SpeedUpsTab: React.FC = (): JSX.Element => {
	return <></>;
};
